/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['http', 'security', './utils', 'endpoints'],
    function(http, security, utils, endpoints) {
        'use strict';
        return {
            trafficViewport: function(options, callback) {
                var pathParams = {};
                var queryParams = {};
                queryParams.key = utils.or(options.key, security.getKey('services/traffic'));
                http.get({
                    url: '{protocol}://' + endpoints.trafficViewport,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    fail: options.fail
                });
            }
        };
    }
);



// WEBPACK FOOTER //
// ./rest/trafficViewport.js